import * as Yup from "yup";
export const ContractUploadValidationSchema = Yup.object().shape({
  name: Yup.string().min(3, "Too Short!").max(50, "Too Long!").required("Contract name is required"),
  description: Yup.string().min(3, "Too Short!").max(250, "Too Long!").required("Contract description is required"),
  protocol: Yup.string().min(2, "Too Short!").max(10, "Too Long!").required("Contract protocol is required")
  // language: Yup.string().min(3, "Too Short!").max(10, "Too Long!").required("Contract language is required")
});
